import {
  Badge,
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Table,
  Tooltip,
} from "antd";
import { useTranslation } from "react-i18next";
import { useLoader } from "../../../../context/LoaderContext";
import classes from "../../../Etablissements/Etablissements.module.css";
import { useContext, useState, useEffect } from "react";
import GlobalContext from "../../../../context/GlobalContext";
import dayjs from "dayjs";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import {
  checkCitizenStatusByCinDn,
  checkCitizenStatusByIdMadDn,
} from "../../../../api/extern";
import {
  addApprenantToSessionContinueNonHomologuee,
  check_apprenant_exist,
  getApprenantsSession,
  getNiveauEducationList,
  getStatutsProfessionnelsList,
  getFonctionsPostesList,
  deleteParticipant,
  updateInfoApprenant
} from "../../../../api/geoprod";


const EtapeListeParticipants = ({
  recap,
  form,
  globalData,
  id_session_formation,
  typesession,
  id_formation,
  participants,
  setParticipants
}) => {
  const { t,i18n } = useTranslation();
  const { setIsLoading } = useLoader();
  const [confirmModal, setConfirmModal] = useState(false);
   const [visibleModalDelete, setVisibleModalDelete] = useState(false);
  const [editingParticipant, setEditingParticipant] = useState(null);
   const [participant, setParticipant] = useState(null);
 const [typeIdentifiant, setTypeIdentifiant] = useState("CIN");
  const [refresh, setRefresh] = useState(false);
  const [visibleForm, setVisibleForm] = useState(false);
  const [niveauEducationOptions, setNiveauEducationOptions] = useState([]);
  const [statutActuelOptions, setStatutActuelOptions] = useState([]);
  const [fonctionOptions, setFonctionOptions] = useState([]);
  const [defaultDisabledFields, setDefaultDisabledFields] = useState({
    first_name: false,
    last_name: false,
    gender: false,
    first_name_fr: false , 
    last_name_fr: false

  });
  const [autreOptions, setAutreOptions] = useState({
    checkAutreNiveauEducation: false,
    checkAutreStatutActuel: false,
    checkAutreFonction: false,
  });
  const { Option } = Select;
  const { nationalityOptions } = useContext(GlobalContext);


  const fetchInitialData = async () => {
      setIsLoading(true);
      let id_affaire;
      if (typesession === "non_homologuee") {
        id_affaire = sessionStorage?.getItem(
          "id_session_formation_non_homologuee"
        );
      } else {
        id_affaire = sessionStorage?.getItem("id_session_formation_continue");
      }
      getApprenantsSession(id_affaire)
      .then((responseListeApprenant) => {
         setParticipants(responseListeApprenant?.message?.Data || []);
     form.setFieldsValue({
      ...form.getFieldsValue(),
        participants: responseListeApprenant?.message?.Data || []
      });


       setIsLoading(false);
          
        })
        .catch((error) => {
          notification.error({
            message: t("Erreur"),
            description: t(error?.data?.message),
            duration: 0,
          });
        });
  };
  useEffect(() => {
    if(!recap)
    {
    fetchInitialData();

    }
  }, [refresh]);


    useEffect(() => {
      if(!recap)
      {
    getNiveauEducationList()
            .then((responseNiveauEduation) => {
              const formattedData =
                responseNiveauEduation.data?.map((item) => ({
                  label: item?.name,
                  value: item?.id,
                })) || [];
              setNiveauEducationOptions(formattedData);
              getStatutsProfessionnelsList()
                .then((responseStatutProf) => {
                  const formattedData =
                    responseStatutProf.data?.map((item) => ({
                      label: item?.name,
                      value: item?.id,
                    })) || [];
                  setStatutActuelOptions(formattedData);

                  getFonctionsPostesList()
                    .then((responseFonctionPoste) => {
                      const formattedData =
                        responseFonctionPoste.data?.map((item) => ({
                          label: item?.name,
                          value: item?.id,
                        })) || [];
                      setFonctionOptions(formattedData);
                      setIsLoading(false);
                    })
                    .catch((error) => {
                      notification.error({
                        message: t("Erreur"),
                        description: t(error?.data?.message),
                        duration: 0,
                      });
                    });
                })
                .catch((error) => {
                  notification.error({
                    message: t("Erreur"),
                    description: t(error?.data?.message),
                    duration: 0,
                  });
                });
            })
            .catch((error) => {
              notification.error({
                message: t("Erreur"),
                description: t(error?.data?.message),
                duration: 0,
              });
            });
      }

  }, []);


  
const handleResetForm = ()=>   
{
form.resetFields(["first_name", "first_name_fr","last_name_fr","date_naissance","num_cin","last_name","num_extrait_naissance","num_passeport","date_expiration_passeport", "gender", "email", "phone", "niveau_education","autre_niveau_education","statut_actuel","autre_statut_actuel","employeur_actuel","fonction","autre_fonction"]);

}

  const handleResetField = () => {

    setVisibleForm(false)
    setDefaultDisabledFields({
      first_name: false,
      last_name: false,
      gender: false,
      first_name_fr : false,
      last_name_fr :false
    });
    handleResetForm();

  };

  const onChangeNationality = (value) => {
    form.setFieldsValue({
    ...form.getFieldsValue(),
    nationality: value });
    handleResetField();
  };

  const handleIdentifiantTypeChange = (value) => {
    setTypeIdentifiant(value)
    form.setFieldsValue({ 
       ...form.getFieldsValue(),
      identifiantType: value });
    form.resetFields(["num_cin", "num_extrait_naissance"]);
    setVisibleForm(false)
  };

  const searchClick = async () => {
     setAutreOptions({
            checkAutreNiveauEducation: false,
            checkAutreStatutActuel: false,
            checkAutreFonction: false,
          });
      const nationality = form.getFieldValue("nationality");
      const fieldsToValidate =
        nationality === "تونسية"
          ? [
              "date_naissance",
              typeIdentifiant === "CIN"
                ? "num_cin"
                : "num_extrait_naissance",
            ]
          : ["date_naissance", "num_passeport"];

       form.validateFields(fieldsToValidate).then(async()=>
      {
       setIsLoading(true);

      const payload = {
        list_apprenant: [
          nationality === "تونسية"
            ? typeIdentifiant === "CIN"
              ? form.getFieldValue("num_cin").toString()
              : form.getFieldValue("num_extrait_naissance").toString()
            : form.getFieldValue("num_passeport").toString(),
        ],
        id_formation: id_formation,
      };

      await check_apprenant_exist(payload)
      .then(async(checkExistResponse)=>{
      if (
        checkExistResponse?.existe &&
        checkExistResponse?.existe?.length > 0
      ) 
      {
        setIsLoading(false);

        notification.error({
          message: t("Error"),
          description: checkExistResponse?.existe[0]?.message,
          duration: 0,
        });
        return;
      }
      
      if (nationality === "تونسية") {
        
        if (typeIdentifiant === "CIN") {
          
         const response = await checkCitizenStatusByCinDn(
            form.getFieldValue("date_naissance"),
            form.getFieldValue("num_cin")
          )
          
           
          if (response !== false) {

        form.setFieldsValue({
         ...form.getFieldsValue(),
        first_name: response?.prenomAr ,
        last_name: response?.nomAr ,
        first_name_fr : response?.prenomFr ,
        last_name_fr : response?.nomFr ,
        gender: response?.genre === "2" ? "Mme" : "Mr",
      });
      setVisibleForm(true)

      setDefaultDisabledFields({
        first_name: nationality === "تونسية" ? !!response?.prenomAr : false,
        last_name: nationality === "تونسية" ? !!response?.nomAr : false,
        gender: nationality === "تونسية" ? !!response?.genre : false,
        first_name_fr : nationality === "تونسية" ? !!response?.prenomFr  : false,
        last_name_fr : nationality === "تونسية" ? !!response?.nomFr  : false,
      });
      setIsLoading(false);
          }
        } else {
          
         const response = await checkCitizenStatusByIdMadDn(
            form.getFieldValue("num_extrait_naissance"),
            form.getFieldValue("date_naissance")
          )
             if (response !== false) {

            form.setFieldsValue({
        ...form.getFieldsValue(),
        first_name: response?.prenom,
        last_name:response?.nom  ,
        first_name_fr : response?.prenomFr,
        last_name_fr : response?.nomFr,
        gender: response?.genre === "2" ? "Mme" : "Mr",
      });
      setVisibleForm(true)

      setDefaultDisabledFields({
        first_name: nationality === "تونسية" ? !!response?.prenom : false,
        last_name: nationality === "تونسية" ? !!response?.nom : false,
        gender: nationality === "تونسية" ? !!response?.genre : false,
        first_name_fr : nationality === "تونسية" ? !!response?.prenomFr: false,
        last_name_fr : nationality === "تونسية" ? !!response?.nomFr: false,
      });
      setIsLoading(false);
     }}
      }
      else
      {
        form.setFieldsValue({
  ...form.getFieldsValue(),
  first_name: "",
  last_name: "",
  first_name_fr :"",
  last_name_fr : "",
  gender: "",
});

      setVisibleForm(true)

      setDefaultDisabledFields({
        first_name: false,
        last_name: false,
        first_name_fr :false,
        last_name_fr : false,
        gender:  false,
      });

      setIsLoading(false);
     
      }


      })
      .catch((error)=>{
         setIsLoading(false);
          notification.error({
          message: t("Erreur"),
          description: t(error?.data?.message),
          duration: 0,
        });
       

      })

      }
    )
      .catch(()=>{
        setIsLoading(false);

        notification.error({
          message: t("Erreur"),
          description: t("Veuillez vérifier tous les champs."),
        });
      
      })
   
  };

  


  const handleAddParticipant = async () => {
  

       form.validateFields().then(async()=>
      {
      const values = form.getFieldsValue();

      setIsLoading(true)
      
      const id_affaire = typesession === "non_homologuee"
        ? sessionStorage?.getItem("id_session_formation_non_homologuee")
        : sessionStorage?.getItem("id_session_formation_continue");

      const newParticipant = {
        name: values.first_name_fr,
        surname: values.last_name_fr,
        name_ar:values.first_name,
        surname_ar:values.last_name,
        DN: dayjs(values.date_naissance, "DD/MM/YYYY").format("YYYY-MM-DD"),
        cin: values.nationality === "تونسية" && values.identifiantType === "CIN" ? values.num_cin : "",
        extrait_naissance: values.nationality === "تونسية" && values.identifiantType === "extrait_naissance" ? values.num_extrait_naissance : "",
        passport: values.nationality !== "تونسية" ? values.num_passeport : "",
        expiration_passeport: values.nationality !== "تونسية" ? dayjs(values.date_expiration_passeport, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
        id_formation: id_formation,
        data_from: {
          typeIdentifiant: values.identifiantType,
        },
        id_affaire: id_affaire,
        nationality: values.nationality,
        adresse_mail: values.email,
        civilite: values.gender,
        tel: values.phone.toString(),
        niveau_education: values.niveau_education,
        statuts_professionnels: values.statut_actuel,
        fonctions_postes: values.fonction,
        niveaux_education_autre: autreOptions?.checkAutreNiveauEducation ? values?.autre_niveau_education : "",
        statuts_professionnels_autre: autreOptions?.checkAutreStatutActuel ? values?.autre_statut_actuel : "",
        fonctions_postes_autre: autreOptions?.checkAutreFonction ? values?.autre_fonction : "",
        employeur_actuel: values?.employeur_actuel
      };
      

        if (editingParticipant === "modifier") {
            newParticipant.id = participant?.id;
        await updateInfoApprenant(newParticipant)
          .then((response) => {
            notification.success({
              message: t("Succès"),
              description: t(response?.message),
              duration: 0,
            });
            
         
            setRefresh(!refresh);
            setConfirmModal(false);
            setEditingParticipant("");
            setAutreOptions({
              checkAutreNiveauEducation: false,
              checkAutreStatutActuel: false,
              checkAutreFonction: false,
            });
            handleResetForm();
          })
          .catch((error) => {
            notification.error({
              message: t("Erreur"),
              description: t(error?.data?.message),
              duration: 0,
            });
            setIsLoading(false);
          });
      } else
      {
   await addApprenantToSessionContinueNonHomologuee({ apprenants: [newParticipant] })
        .then((response) => {
          notification.success({
            message: t("Succès"),
            description: t(response?.message),
            duration: 0,
          });
          
         
          
          setRefresh(!refresh);
          setConfirmModal(false);
          setEditingParticipant("");
            setAutreOptions({
            checkAutreNiveauEducation: false,
            checkAutreStatutActuel: false,
            checkAutreFonction: false,
          });
            handleResetForm();
        })
        .catch((error) => {
          notification.error({
            message: t("Erreur"),
            description: t(error?.data?.message),
            duration: 0,
          });
          setIsLoading(false);
        });
      }
      })
       .catch(()=>{
        notification.error({
          message: t("Erreur"),
          description: t("Veuillez vérifier tous les champs."),
        });
        setIsLoading(false);
      
      })

  };












const handleEditParticipant = async (participant,action) => {

     setParticipant(participant);
    setEditingParticipant(action);
    const identifiantType = participant?.extrait_naissance ? "extrait_naissance" : participant?.cin ? "CIN" : "passeport";
    const formValues = {
      ...participant,
      nationality: participant?.nationality,
      identifiantType,
      [identifiantType === "CIN" ? "num_cin" : 
       identifiantType === "extrait_naissance" ? "num_extrait_naissance" : 
       "num_passeport"]: participant?.cin || participant?.extrait_naissance || participant?.passport,
      
      date_naissance: participant.DN ? dayjs(participant.DN, "YYYY-MM-DD") : null,
      date_expiration_passeport: participant?.expiration_passeport ? 
      dayjs(participant?.expiration_passeport, "YYYY-MM-DD") : null,
      first_name: participant?.name_ar,
      last_name: participant?.surname_ar,
      first_name_fr: participant?.name,
      last_name_fr:participant?.surname,
      gender: participant?.civilite,
      email: participant?.adresse_mail,
      phone: participant?.tel,
      employeur_actuel:participant?.employeur_actuel,
      niveau_education: participant?.niveaux_education_id,
      statut_actuel: participant?.statuts_professionnels_id,
      fonction: participant?.fonctions_postes_id,
      autre_niveau_education: participant?.niveaux_education_autre,
      autre_statut_actuel: participant?.statuts_professionnels_autre,
      autre_fonction: participant?.fonctions_postes_autre,
      
    };

    setAutreOptions({
      checkAutreNiveauEducation: !!participant?.niveaux_education_autre,
      checkAutreStatutActuel: !!participant?.statuts_professionnels_autre,
      checkAutreFonction: !!participant?.fonctions_postes_autre,
    });

   setTypeIdentifiant(identifiantType)
    // form.setFieldsValue(formValues);
    form.setFieldsValue({
  ...form.getFieldsValue(),
  ...formValues
});
    setVisibleForm(true);
    setConfirmModal(true);
};
 
  const showDeleteConfirm = (participant) => {
    setParticipant(participant);
    setVisibleModalDelete(true);
  };
 const handleDeleteParticipant = async () => {
   if (!participant) return;
  setIsLoading(true)
      await deleteParticipant(participant?.id, id_formation).then((response)=>
      {
         notification.success({
            message: t("Succès"),
            description: t(response?.message),
            duration: 0,
          });
           setRefresh(!refresh);
          setIsLoading(false)
            setVisibleModalDelete(false);
        setParticipant(null);
      }
    )
      .catch((error)=>{
         notification.error({
            message: t("Erreur"),
            description: t(error?.data?.message),
            duration: 0,
          });
          setIsLoading(false)
      })
  };

  const columns = [
     {
      title: t("Nationalité"),
      dataIndex: "nationality",
      key: "nationality",
    },
    {
      title: t("Identifiant"),
      key: "identifiant",
      render: (_, record) =>
          record.extrait_naissance 
          ? record.extrait_naissance 
            : record.cin ? 
             record.cin 
          : record.passport,
    },
    
    {
      title: t("Prénom"),
      dataIndex: "surname",
      key: "surname",
    },
   {
      title: t("Nom"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("Actions"),
      key: "actions",
      render: (_, record) => (
        <>
            <Button
                type="link"
                icon={<EyeOutlined />}
                onClick={() => handleEditParticipant(record,"consulter")}
              />
              {
                 sessionStorage.getItem("consulter") !== "true" && !recap &&
                 ( <>
                  <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEditParticipant(record,"modifier")}
          />
          <Button
            type="link"
            danger
            icon={<DeleteOutlined />}
            onClick={() =>   showDeleteConfirm(record)}
          />
                 </>
                )
              }
         
        </>
      ),
    },
  ];
const handleModalCancel = () => {
  setConfirmModal(false);
  setEditingParticipant(null);   
  setVisibleForm(false);
  form.resetFields(["first_name", "first_name_fr","last_name_fr","date_naissance","num_cin","last_name","num_extrait_naissance","num_passeport","date_expiration_passeport", "gender", "email", "phone", "niveau_education","autre_niveau_education","statut_actuel","autre_statut_actuel","employeur_actuel","fonction","autre_fonction"]);
  setRefresh(prev => !prev);
};
  return (
  <>
      

       <Card 
        className={classes.listeCard} 
        bordered={false}

        title={
  <div 
  style={{ 
    textAlign: i18n?.dir() === "ltr" ? "left" : "right",  
    fontSize: "18px",
    color: "#195a99",
    display: "flex",
    alignItems: "center",
  }}>
    {t("Liste des Participants")}
    {participants?.length > 0 && (
      <Tooltip 
        title={`${t("Nombre de participants")} : ${participants?.length}`}
      >
       <Badge 
          count={participants?.length} 
          style={{ 
            backgroundColor: '#1890ff',
            marginLeft:'10px',
            fontSize: "10px",
            fontWeight: "bold"
          }} 
        />
      </Tooltip>
    )}
  </div>
}
  

        
      >
        <Form.List name="participants">
          {(fields, { add, remove }) => (
            <>
              <Table
                locale={{ emptyText: t("Aucune donnée") }}
                columns={columns}
                dataSource={participants}
                className="ant-border-space"
                style={{ overflowX: "auto" }}
                pagination={true}
                rowKey="id"


                  title={
      !recap
        ? () => (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                type="primary"
                disabled={id_session_formation && sessionStorage.getItem("consulter") === "true"}
                onClick={() => {
                    handleResetForm();
                  setVisibleForm(false);
                  setConfirmModal(true);
                }}
              >
                {t("Ajouter participant")}
              </Button>
              
            </div>
          )
        : ""
    }
              />
            </>
          )}
        </Form.List>
      </Card>
<Modal
maskClosable={false}
 destroyOnClose={true}
  open={confirmModal}
  
  footer={null}
  width={"100%"}
   onCancel={handleModalCancel}

  title={
  editingParticipant === "consulter"
  ? t("Consulter les informations du participant")
  : editingParticipant === "modifier"
  ? t("Modifier participant")
  : t("Ajouter participant")
  }
>
 
    <Row gutter={16}
     >
      <Col xs={24} sm={8}>
        <Form.Item
          label={t("Nationalité")}
          name="nationality"
          rules={[{ required: true, message: t("Veuillez remplir ce champ") }]}
        >
          <Select
            onChange={onChangeNationality}
            optionFilterProp="label"
            showSearch
            options={nationalityOptions}
            disabled={editingParticipant}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Col>

      <Col xs={24} sm={8}>
        <Form.Item
          label={t("Date de naissance")}
          name="date_naissance"
          rules={[{ required: true, message: t("Veuillez remplir ce champ") }]}
        >
          <DatePicker
            format="DD/MM/YYYY"
            placeholder="JJ/MM/AAAAA"
            style={{ width: '100%' }}
            onChange={() => setVisibleForm(false)}
            disabledDate={(current) =>
              current && current > dayjs().subtract(15, "years").endOf("day")
            }
            disabled={editingParticipant}
          />
        </Form.Item>
      </Col>

      {form.getFieldValue("nationality") === "تونسية" && (
        <Col xs={24} sm={8}>
          <Form.Item
            label={t("Type d'identifiant")}
            name="identifiantType"
            rules={[{ required: true, message: t("Veuillez remplir ce champ") }]}
          >
            <Select
              onChange={handleIdentifiantTypeChange}
              disabled={editingParticipant}
              style={{ width: '100%' }}
            >
              <Option value="CIN">CIN</Option>
              <Option value="extrait_naissance">Extrait de naissance</Option>
            </Select>
          </Form.Item>
        </Col>
      )}

      {form.getFieldValue("nationality") === "تونسية" && (
        <Col xs={24} sm={8}>
          {typeIdentifiant=== "CIN" ? (
            <Form.Item
              label={t("Numéro CIN")}
              name="num_cin"
              rules={[
                { required: true, message: t("Veuillez remplir ce champ") },
                { pattern: /^\d{8}$/, message: t("Veuillez vérifier ce champ.") },
              ]}
            >
              <Input
                maxLength={8}
                disabled={editingParticipant}
                onChange={(e) => {
                  form.setFieldsValue({
                    ...form.getFieldsValue(),
                    num_cin: e.target.value.replace(/[^0-9]/g, "")
                  });
                  setVisibleForm(false);
                }}
              />
            </Form.Item>
          ) : (
            <Form.Item
              label={t("Numéro de l'extrait de naissance")}
              name="num_extrait_naissance"
              rules={[
                { required: true, message: t("Veuillez remplir ce champ") },
                { pattern: /^\d{10}$/, message: t("Veuillez vérifier ce champ.") },
              ]}
            >
              <Input
                maxLength={10}
                disabled={editingParticipant}
                onChange={(e) => {
                  form.setFieldsValue({
                  ...form.getFieldsValue(),
                  num_extrait_naissance: e.target.value.replace(/[^0-9]/g, "")
                });
                  setVisibleForm(false);
                }}
              />
            </Form.Item>
          )}
        </Col>
      )}

      {form.getFieldValue("nationality") !== "تونسية" && (
        <Col xs={24} sm={8}>
          <Form.Item
            label={t("N° passeport")}
            name="num_passeport"
            rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
          >
            <Input
              onChange={() => setVisibleForm(false)}
              disabled={editingParticipant}
            />
          </Form.Item>
        </Col>
      )}

      {!editingParticipant && (
        <Col xs={24} sm={8}>
          <Form.Item label=" " colon={false} style={{ display: 'flex', alignItems: 'flex-end' }}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={searchClick}
              disabled={visibleForm}
              style={{ width: '100%' }}
            >
              {t("Rechercher")}
            </Button>
          </Form.Item>
        </Col>
      )}

      {visibleForm && (
        <>
          {form.getFieldValue("nationality") !== "تونسية" && (
            <Col xs={24} sm={8}>
              <Form.Item
                label={t("Date d'expiration du passeport")}
                name="date_expiration_passeport"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder="JJ/MM/AAAAA"
                  disabled={editingParticipant === "consulter"}
                  style={{ width: '100%' }}
                  disabledDate={(current) =>
                    current && current < dayjs().add(3, "month").startOf("day")
                  }
                />
              </Form.Item>
            </Col>
          )}

          <Col xs={24} sm={8}>
            <Form.Item
              label={t("Nom (En français)")}
              name="last_name_fr"
              rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      pattern: /^[a-zA-ZÀ-ÿ\s-]+$/,
                      message: t(
                        "Veuillez entrer uniquement des caractères français."
                      ),
                    },
                  ]}
            >
              <Input
                disabled={defaultDisabledFields?.last_name_fr || editingParticipant }
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
              label={t("Prénom (En français)")}
              name="first_name_fr"
               rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      pattern: /^[a-zA-ZÀ-ÿ\s-]+$/,
                      message: t(
                        "Veuillez entrer uniquement des caractères français."
                      ),
                    },
                  ]}
           
            >
              <Input
                disabled={defaultDisabledFields?.first_name_fr || editingParticipant}
              />
            </Form.Item>
          </Col>


   <Col xs={24} sm={8}>
            <Form.Item
              label={t("Nom (En arabe)")}
              name="last_name"
               rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      pattern: /^[\u0600-\u06FF0-9\s]+$/,
                      message: t(
                        "Veuillez entrer uniquement des caractères arabes."
                      ),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() === "") {
                          return Promise.reject(
                            t("Veuillez remplir ce champ.")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
            >
              <Input
                disabled={defaultDisabledFields?.last_name || editingParticipant }
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
              label={t("Prénom (En arabe)")}
              name="first_name"
              rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      pattern: /^[\u0600-\u06FF0-9\s]+$/,
                      message: t(
                        "Veuillez entrer uniquement des caractères arabes."
                      ),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() === "") {
                          return Promise.reject(
                            t("Veuillez remplir ce champ.")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
            >
              <Input
                disabled={defaultDisabledFields?.first_name || editingParticipant}
              />
            </Form.Item>
          </Col>
          





          <Col xs={24} sm={8}>
            <Form.Item
              label={t("Genre")}
              name="gender"
              rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
            >
              <Select
                disabled={defaultDisabledFields.gender || editingParticipant}
                style={{ width: '100%' }}
              >
                <Option value="Mme">Féminin - أنثى</Option>
                <Option value="Mr">Masculin - ذكر</Option>
              </Select>
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
              label={t("Adresse e-mail")}
              name="email"
              rules={[
                { required: true, message: t("Veuillez remplir ce champ.") },
                { type: "email", message: t("Veuillez vérifier ce champ.") },
              ]}
            >
              <Input disabled={editingParticipant === "consulter"} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
              label={t("Numéro de téléphone")}
              name="phone"
              rules={[
                { required: true, message: t("Veuillez remplir ce champ.") },
                {
                  pattern: form.getFieldValue("nationality") === "تونسية" ? /^\d{8}$/ : /^\d+$/,
                  message: t("Veuillez vérifier ce champ.")
                },
              ]}
            >
              <Input
                disabled={editingParticipant === "consulter"}
                maxLength={form.getFieldValue("nationality") === "تونسية" ? 8 : undefined}
                onChange={(e) => {
                  form.setFieldsValue({
                  ...form.getFieldsValue(),
                  phone: e.target.value.replace(/[^0-9]/g, "")
                });
                }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
              label={t("Niveau d'éducation")}
              name="niveau_education"
              rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
            >
              <Select
                showSearch
                optionFilterProp="label"
                disabled={editingParticipant === "consulter"}
                options={niveauEducationOptions}
                style={{ width: '100%' }}
                onChange={(value) => {
                  setAutreOptions(prev => ({
                    ...prev,
                    checkAutreNiveauEducation: value === parseInt(import.meta.env.VITE_APP_ID_NIVEAU_EDUCATION_AUTRE_INFO_PARTICIPANT)
                  }));
                }}
              />
            </Form.Item>
          </Col>

          {autreOptions?.checkAutreNiveauEducation && (
            <Col xs={24} sm={8}>
              <Form.Item
                label={t("Autre niveau d'éducation")}
                name="autre_niveau_education"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Input disabled={editingParticipant === "consulter"} />
              </Form.Item>
            </Col>
          )}

{
  typesession !== "non_homologuee" && 
(<>
       <Col xs={24} sm={8}>
            <Form.Item
              label={t("Statut actuel")}
              name="statut_actuel"
              rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
            >
              <Select
                showSearch
                disabled={editingParticipant === "consulter"}
                optionFilterProp="label"
                options={statutActuelOptions}
                style={{ width: '100%' }}
                onChange={(value) => {
                  setAutreOptions(prev => ({
                    ...prev,
                    checkAutreStatutActuel: value === parseInt(import.meta.env.VITE_APP_ID_STATUT_ACTUEL_AUTRE_INFO_PARTICIPANT)
                  }));
                }}
              />
            </Form.Item>
          </Col>

          {autreOptions?.checkAutreStatutActuel && (
            <Col xs={24} sm={8}>
              <Form.Item
                label={t("Autre statut actuel")}
                name="autre_statut_actuel"
                rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
              >
                <Input disabled={editingParticipant === "consulter"} />
              </Form.Item>
            </Col>
          )}

          <Col xs={24} sm={8}>
            <Form.Item
              label={t("Employeur actuel")}
              name="employeur_actuel"
              rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
            >
              <Input disabled={editingParticipant === "consulter"} />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
              label={t("Fonction/Poste occupé")}
              name="fonction"
              rules={[{ required: true, message: t("Veuillez remplir ce champ.") }]}
            >
              <Select
                disabled={editingParticipant === "consulter"}
                showSearch
                optionFilterProp="label"
                style={{ width: '100%' }}
                options={fonctionOptions}
                onChange={(value) => {
                  setAutreOptions(prev => ({
                    ...prev,
                    checkAutreFonction: value === parseInt(import.meta.env.VITE_APP_ID_FONCTION_OCUUPE_AUTRE_INFO_PARTICIPANT)
                  }));
                }}
              />
            </Form.Item>
          </Col>

          {autreOptions?.checkAutreFonction && (
            <Col xs={24} sm={8}>
              <Form.Item
                label={t("Autre Fonction/Poste occupé")}
                name="autre_fonction"
                rules={[{ required: true, message: t("Veuillez remplir ce champ") }]}
              >
                <Input disabled={editingParticipant === "consulter"} />
              </Form.Item>
            </Col>
          )}
          </>
  )
}
       
        </>
      )}
    </Row>

    <div style={{ marginTop: 24, textAlign: "right" }}>
      <Button
        onClick={() => {
          setConfirmModal(false);
          setEditingParticipant("");
          handleResetForm();

        }}
        style={{ marginRight: 8 }}
      >
        {t("Annuler")}
      </Button>
      { !editingParticipant  && (
        <Button
          type="primary"
          disabled={!visibleForm}
          onClick={handleAddParticipant}
        >
          {t("Ajouter")}
        </Button>
      )}

        { editingParticipant === "modifier"   && (
        <Button
          type="primary"
          disabled={!visibleForm}
          onClick={handleAddParticipant}
        >
          {t("Modifier")}
        </Button>
      )}
    </div>
</Modal>

      <Modal
      maskClosable={false}
          open={visibleModalDelete}
          footer={null}
          width={600}
          onCancel={() => setVisibleModalDelete(false)}
        >
          <h4>
            {
               t(
                `Êtes-vous sûr de vouloir supprimer le participant ${participant?.name} ${participant?.surname}  ? Cette action est irréversible.`
              )
              }
          </h4>
          <Button
            type="primary"
            onClick={() => handleDeleteParticipant()}
          >
            {t("Oui")}
          </Button>
          <Button
            type="primary"
            style={{ marginInline: "15px" }}
            onClick={() => setVisibleModalDelete(false)}
          >
            {t("Non")}
          </Button>
        </Modal>

    </>
  );
};

export default EtapeListeParticipants;
